import { makeAutoObservable } from "mobx";

export class InspirationStore {
  curTab: "gallery" | "album" = "gallery";

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setCurTab(tab: InspirationStore["curTab"]) {
    this.curTab = tab;
  }
}

export const inspirationStore = new InspirationStore();
